import { assetsPath } from "../../utils";

const selectPath = (str) => `${assetsPath("laguna-beachside")}${str}`;

const landingPage = [
  { image: selectPath("/images/residence/landing-page/1.jpg") },
  { image: selectPath("/images/residence/landing-page/2.jpg") },
  { image: selectPath("/images/residence/landing-page/3.jpg") },
  { image: selectPath("/images/residence/landing-page/4.jpg") },
  { image: selectPath("/images/residence/landing-page/5.jpg") },
  { image: selectPath("/images/residence/landing-page/6.jpg") },
];

const type = [
  {
    // name: "ONE-BEDROOM",
    name: {
      en: "ONE-BEDROOM",
      cn: "1-卧室",
      ru: "1-Спальня",
    },
    thumbnail: [
      {
        image: selectPath("/images/residence/thumbnail/1-bed/1.jpg"),
      },
      {
        image: selectPath("/images/residence/thumbnail/1-bed/1.jpg"),
      },
    ],
    buttons: [
      {
        type: "description",
        value: 0,
        name: "Description",
        title: "Description",
        description: {
          en:
            "<p>Ideal for the modern lifestyle, the 1-bedroom condominium units at Laguna Beachside start at a spacious 59 sqm. A choice of fit-out options offers the flexibility for owners to customise their own living area.</p>",
          cn:
            "<p>悦海苑的一卧室公寓面积为59平方米起，空间宽敞，是现代生活方式的理想选择。可选的装修方案为业主带来个性定制起居空间的灵活性。</p>",
          ru:
            "<p>Ideal for the modern lifestyle, the 1-bedroom condominium units at Laguna Beachside start at a spacious 59 sqm. A choice of fit-out options offers the flexibility for owners to customise their own living area.</p>",
        },
        images: [
          {
            image: selectPath("/images/residence/description/1-bed/1.jpg"),
          },
          {
            image: selectPath("/images/residence/description/1-bed/2.jpg"),
          },
        ],
      },
      {
        type: "plan",
        // name: "TYPE A",
        name: {
          en: "TYPE A",
          cn: "A 型",
          ru: "тип A",
        },
        value: 1,
        floorPlan: {
          en: selectPath("/images/residence/floor-plan/1-bed/en/1.png"),
          ru: selectPath("/images/residence/floor-plan/1-bed/eu/1.png"),
          cn: selectPath("/images/residence/floor-plan/1-bed/cn/1.png"),
        },
        images: [],
        image360: [],
        imageVirtual: [],
      },
      {
        type: "plan",
        // name: "TYPE B",
        name: {
          en: "TYPE B",
          cn: "B 型",
          ru: "тип B",
        },
        value: 2,
        floorPlan: {
          en: selectPath("/images/residence/floor-plan/1-bed/en/2.png"),
          ru: selectPath("/images/residence/floor-plan/1-bed/ru/2.png"),
          cn: selectPath("/images/residence/floor-plan/1-bed/cn/2.png"),
        },
        images: [],
        image360: [],
        imageVirtual: [],
      },
    ],
  },
  {
    // name: "TWO-BEDROOM",
    name: {
      en: "TWO-BEDROOM",
      cn: "2-卧室",
      ru: "2-Спальня",
    },
    thumbnail: [
      {
        image: selectPath("/images/residence/thumbnail/2-bed/1.jpg"),
      },
      {
        image: selectPath("/images/residence/thumbnail/2-bed/1.jpg"),
      },
    ],
    buttons: [
      {
        type: "description",
        value: 0,
        name: "Description",
        title: "Description",
        description: {
          en:
            "<p>The larger 2-bedroom units are designed to enjoy maximum panoramic views from their respective full width lanai.</p>",
          cn: "<p>更大的两卧室公寓可从各自的全宽休闲阳台欣赏到开阔的全景。</p>",
          ru:
            "<p>The larger 2-bedroom units are designed to enjoy maximum panoramic views from their respective full width lanai.</p>",
        },
        images: [
          {
            image: selectPath("/images/residence/description/2-bed/1.jpg"),
          },
          {
            image: selectPath("/images/residence/description/2-bed/2.jpg"),
          },
          {
            image: selectPath("/images/residence/description/2-bed/3.jpg"),
          },
        ],
      },
      {
        type: "plan",
        // name: "TYPE A",
        name: {
          en: "TYPE A",
          cn: "A 型",
          ru: "тип A",
        },
        value: 1,
        floorPlan: {
          en: selectPath("/images/residence/floor-plan/2-bed/en/1.png"),
          ru: selectPath("/images/residence/floor-plan/2-bed/ru/1.png"),
          cn: selectPath("/images/residence/floor-plan/2-bed/cn/1.png"),
        },
        images: [],
        image360: [],
        imageVirtual: [],
        disclaimer: {
          en:
            "*The garden area shown on the first-floor plan shall be available for exclusive use of the owners of the first-floor condominium units.",
          cn: "*一楼楼层图上所显示的花园区域为一楼公寓业主的专属区域.",
          ru:
            "*The garden area shown on the first-floor plan shall be available for exclusive use of the owners of the first-floor condominium units.",
        },
      },
    ],
  },
  {
    // name: "THREE-BEDROOM",
    name: {
      en: "THREE-BEDROOM",
      cn: "3-卧室",
      ru: "3-Спальня",
    },
    thumbnail: [
      {
        image: selectPath("/images/residence/thumbnail/3-bed/1.jpg"),
      },
      {
        image: selectPath("/images/residence/thumbnail/3-bed/1.jpg"),
      },
    ],
    buttons: [
      {
        type: "description",
        value: 0,
        name: "Description",
        title: "Description",
        description: {
          en:
            "<p>The 3-bedroom units with the unique semi-outdoor lanai feature provide additional living space, which can be opened up to extend the balcony for relaxed outdoor living, or closed off with an optional glass screen to increase interior floor space.</p>",
          cn:
            "<p>三卧室公寓拥有独特的半露天休闲阳台，提供额外的起居空间，并可开放至阳台，尽享休闲户外生活，或选用玻璃封闭以增加室内空间。</p>",
          ru:
            "<p>The 3-bedroom units with the unique semi-outdoor lanai feature provide additional living space, which can be opened up to extend the balcony for relaxed outdoor living, or closed off with an optional glass screen to increase interior floor space.</p>",
        },
        images: [
          {
            image: selectPath("/images/residence/description/3-bed/1.jpg"),
          },
          {
            image: selectPath("/images/residence/description/3-bed/2.jpg"),
          },
        ],
      },
      {
        type: "plan",
        // name: "TYPE A",
        name: {
          en: "TYPE A",
          cn: "A 型",
          ru: "тип A",
        },
        value: 1,
        floorPlan: {
          en: selectPath("/images/residence/floor-plan/3-bed/en/1.png"),
          ru: selectPath("/images/residence/floor-plan/3-bed/ru/1.png"),
          cn: selectPath("/images/residence/floor-plan/3-bed/cn/1.png"),
        },
        images: [],
        image360: [],
        imageVirtual: [],
        disclaimer: {
          en:
            "*The garden area shown on the first-floor plan shall be available for exclusive use of the owners of the first-floor condominium units.",
          cn: "*一楼楼层图上所显示的花园区域为一楼公寓业主的专属区域.",
          ru:
            "*The garden area shown on the first-floor plan shall be available for exclusive use of the owners of the first-floor condominium units.",
        },
      },
      {
        type: "plan",
        // name: "TYPE B",
        name: {
          en: "TYPE B",
          cn: "B 型",
          ru: "тип B",
        },
        value: 2,
        floorPlan: {
          en: selectPath("/images/residence/floor-plan/3-bed/en/2.png"),
          ru: selectPath("/images/residence/floor-plan/3-bed/ru/2.png"),
          cn: selectPath("/images/residence/floor-plan/3-bed/cn/2.png"),
        },
        images: [],
        image360: [],
        imageVirtual: [],
        disclaimer: {
          en:
            "*The garden area shown on the first-floor plan shall be available for exclusive use of the owners of the first-floor condominium units.",
          cn: "*一楼楼层图上所显示的花园区域为一楼公寓业主的专属区域.",
          ru:
            "*The garden area shown on the first-floor plan shall be available for exclusive use of the owners of the first-floor condominium units.",
        },
      },
    ],
  },
];

export default {
  landingPage,
  type,
};



// WEBPACK FOOTER //
// ./src/data/LagunaBeachside/residence.js